<template>
  <tr class="fixed-sum-table-row">
    <slot name='prepend' />

    <td
      v-for='(header, index) of headers'
      :key='index'
    >
      <span>{{ values[header.value] | emptyValueAsHyphen }}</span>
    </td>

    <slot name='append' />
  </tr>
</template>

<script>
export default {
  name: 'FixedSumRowDesktop',
  props: {
    headers: { type: Array, required: true },
    values: { type: Object, default: () => ({}) }
  },
};
</script>
